import { Dispatch } from 'redux';
import api from '../services/api';

import { handleError } from './dashboard';

export class ReportActionTypes {
  public static readonly IS_LOADING = 'IS_LOADING';
  public static readonly AVAILABLE_REPORTS_DATA = 'AVAILABLE_REPORTS_DATA';
  public static readonly EXEC_SUMMARY_URL = 'EXEC_SUMMARY_URL';
  public static readonly PREV_OFFER_DATA = 'PREV_OFFER_DATA';
  public static readonly OVERRIDE_REPORT_DATA = 'OVERRIDE_REPORT_DATA';
  public static readonly DATA_DOWNLOAD_FLAG = 'DATA_DOWNLOAD_FLAG';
  public static readonly OVERRIDE_DATA_DOWNLOAD_FLAG =
    'OVERRIDE_DATA_DOWNLOAD_FLAG';
  public static readonly GET_OFFER_COMPILANCE = 'GET_OFFER_COMPILANCE';
  public static readonly GET_RENEWAL_FORECAST = 'GET_RENEWAL_FORECAST';
  public static readonly SET_LEASE_PRICE_DATA = 'SET_LEASE_PRICE_DATA';
}

export const setLoading = (dispatch: Dispatch, isLoading: boolean) =>
  dispatch({ type: ReportActionTypes.IS_LOADING, payload: isLoading });

export const getOfferCompilance = () => (dispatch: Dispatch) => {
  api
    .getOfferCompilance()
    .then((res) => {
      dispatch({
        type: ReportActionTypes.GET_OFFER_COMPILANCE,
        payload: res.data,
        meta: {
          track: true,
        },
      });
    })
    .catch((err) => {
      console.log(err);
      handleError(err, dispatch);
    });
};

export const getRenewalForecast = () => (dispatch: Dispatch) => {
  api
    .getRenewalForecast()
    .then((res) => {
      dispatch({
        type: ReportActionTypes.GET_RENEWAL_FORECAST,
        payload: res.data,
        meta: {
          track: true,
        },
      });
    })
    .catch((err) => {
      console.log(err);
      handleError(err, dispatch);
    });
};

export const fetchAvailableReports = () => (dispatch: Dispatch) => {
  dispatch({
    type: ReportActionTypes.IS_LOADING,
    payload: true,
  });

  api
    .getOfferCycles()
    .then((res) => {
      dispatch({
        type: ReportActionTypes.AVAILABLE_REPORTS_DATA,
        payload: res.data,
        meta: {
          track: true,
        },
      });
    })
    .catch((err) => {
      handleError(err, dispatch);
      dispatch({
        type: ReportActionTypes.IS_LOADING,
        payload: false,
      });
    })
    .finally(() => {
      dispatch({
        type: ReportActionTypes.IS_LOADING,
        payload: false,
      });
    });
};

export const downloadExecSummary =
  (offer_cycle: string) => (dispatch: Dispatch) => {
    dispatch({
      type: ReportActionTypes.IS_LOADING,
      payload: true,
    });

    api
      .getExecDownloadUrl({ offer_cycle })
      .then((res) => {
        dispatch({
          type: ReportActionTypes.EXEC_SUMMARY_URL,
          payload: res.data,
          meta: {
            track: true,
            includeData: true,
          },
        });
      })
      .catch((err) => handleError(err, dispatch))
      .finally(() => {
        dispatch({
          type: ReportActionTypes.IS_LOADING,
          payload: false,
        });
      });
  };

export const getPrevOfferData =
  (offer_cycle: string[]) => (dispatch: Dispatch) => {
    dispatch({
      type: ReportActionTypes.IS_LOADING,
      payload: true,
    });
    api
      .getPrevOfferData({ offer_cycle })
      .then((res) => {
        dispatch({
          type: ReportActionTypes.PREV_OFFER_DATA,
          payload: { offer_cycle, data: res.data },
          meta: {
            track: true,
          },
        });
      })
      .catch((err) => handleError(err, dispatch))
      .finally(() => {
        dispatch({
          type: ReportActionTypes.IS_LOADING,
          payload: false,
        });
      });
  };

export const getOverrideReportData =
  (offer_cycle: string[]) => (dispatch: Dispatch) => {
    dispatch({
      type: ReportActionTypes.IS_LOADING,
      payload: true,
    });
    api
      .getOverrideReportData(offer_cycle)
      .then((res) => {
        dispatch({
          type: ReportActionTypes.OVERRIDE_REPORT_DATA,
          payload: { offer_cycle, data: res.data },
          meta: {
            track: true,
          },
        });
      })
      .catch((err) => handleError(err, dispatch))
      .finally(() => {
        dispatch({
          type: ReportActionTypes.IS_LOADING,
          payload: false,
        });
      });
  };

export const clearExecDownloadUrl = () => (dispatch: Dispatch) =>
  dispatch({
    type: ReportActionTypes.EXEC_SUMMARY_URL,
    payload: { url: undefined },
  });
export const clearPrevDataDownloadFlag = () => (dispatch: Dispatch) =>
  dispatch({
    type: ReportActionTypes.DATA_DOWNLOAD_FLAG,
    payload: undefined,
  });
export const setPrevDataDownloadFlag =
  (offer_cycle: string[]) => (dispatch: Dispatch) =>
    dispatch({
      type: ReportActionTypes.DATA_DOWNLOAD_FLAG,
      payload: offer_cycle,
      meta: {
        track: true,
      },
    });
export const clearOverrideDataDownloadFlag = () => (dispatch: Dispatch) =>
  dispatch({
    type: ReportActionTypes.OVERRIDE_DATA_DOWNLOAD_FLAG,
    payload: undefined,
  });
export const setOverrideDataDownloadFlag =
  (offer_cycle: string[]) => (dispatch: Dispatch) =>
    dispatch({
      type: ReportActionTypes.OVERRIDE_DATA_DOWNLOAD_FLAG,
      payload: offer_cycle,
      meta: {
        track: true,
      },
    });

export const getLeasePriceReport =
  (startDate: any, length: any, bedroom: any) => (dispatch: Dispatch) => {
    //
    if (bedroom !== undefined) {
      setLoading(dispatch, true);

      let prevDate = startDate.split('-');
      prevDate[0] = parseInt(prevDate[0]) - 1;
      prevDate = prevDate.join('-');

      Promise.all([
        api.getLeaseSummary({
          startDate: startDate,
          length: length,
          bedRoom: bedroom,
        }),
        api.getLeaseSummary({
          startDate: prevDate,
          length: length,
          bedRoom: bedroom,
        }),
      ])
        .then(([res1, res2]) => {
          console.log(res1);
          dispatch({
            type: ReportActionTypes.SET_LEASE_PRICE_DATA,
            payload: {
              current: res1.data,
              previous: res2.data,
            },
            meta: {
              track: true,
            },
          });
          setLoading(dispatch, false);
        })
        .catch((err) => handleError(err, dispatch));
    }

    /*
            dispatch({
          type: IN_LEASE_PRICING_ACTIONS.SET_LEASE_PRICE_SUMMARY,
          payload: {
            current: res1.data,
            previous: res2.data,
          },
        });
        setLoading(dispatch, false);
    */
    //setLoading(dispatch, false);
  };
